import { Map, List } from 'immutable';
// - Import image gallery action types
import { ImageGalleryActionType } from 'constants/imageGalleryActionType';
import { ImageGalleryState } from './ImageGalleryState';
/**
 *  Image gallery reducer
 */
export var imageGalleryReducer = function (state, action) {
    if (state === void 0) { state = Map(new ImageGalleryState()); }
    var payload = action.payload;
    switch (action.type) {
        /* ----------------- CRUD ----------------- */
        case ImageGalleryActionType.ADD_IMAGE_GALLERY:
            return state
                .mergeIn(['images'], List([payload]));
        case ImageGalleryActionType.ADD_IMAGE_LIST_GALLERY:
            return state
                .set('images', List(payload))
                .set('loaded', true);
        case ImageGalleryActionType.DELETE_IMAGE:
            return state
                .update('images', function (images) {
                return images.filter(function (image) { return image.id !== payload; });
            });
        case ImageGalleryActionType.SET_IMAGE_URL:
            return state
                .setIn(['imageURLList', payload.name], payload.url);
        case ImageGalleryActionType.SEND_IMAGE_REQUEST:
            return state
                .mergeIn(['imageRequests'], payload);
        case ImageGalleryActionType.CLEAT_ALL_DATA_IMAGE_GALLERY:
            return Map(new ImageGalleryState());
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/imageGallery/imageGalleryReducer.ts
// module id = 563
// module chunks = 50